import React from 'react';
import PropTypes from 'prop-types';
import {SelectDropdown} from '../../SelectDropdown';
import './style.scss';

export class AnswerStep extends React.Component {
  renderOptionFeedback = () => {
    if (this.props.showFeedback) {
      if (this.props.value === this.props.droppedId) {
        return <p className='correct'>{this.props.feedbackSuccess}</p>;
      } else {
        return <p className='incorrect'>{this.props.feedbackError}</p>;
      }
    } else return null;
  };

  onChange = (event) => {
    const {componentID} = this.props;
    const {name, value} = event;
    if (value !== null) {
      this.props.selectOption({
        componentID,
        name,
        value,
      });
    }
  };

  wrapperClass = () => {
    let classList = ['answer-step'];
    if (this.props.showFeedback) {
      if (this.props.value === this.props.droppedId) {
        classList.push('correct');
      } else {
        classList.push('incorrect');
      }
    }
    return classList.join(' ');
  };

  render() {
    return (
      <>
        <div className={this.wrapperClass()}>
          <SelectDropdown
            disabled={this.props.disabled}
            label={this.props.step}
            name={this.props.value}
            options={this.props.allOptions}
            onChange={this.onChange}
            value={this.props.droppedId}
            placeholder={this.props.placeholder}
          />
        </div>
        {this.renderOptionFeedback()}
      </>
    );
  }
}

AnswerStep.propTypes = {
  allOptions: PropTypes.array,
  componentID: PropTypes.number,
  droppedId: PropTypes.number || PropTypes.any,
  feedbackError: PropTypes.string,
  feedbackSuccess: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string,
  selectOption: PropTypes.func,
  showFeedback: PropTypes.bool,
  step: PropTypes.string,
  value: PropTypes.number,
  disabled: PropTypes.bool,
};
